// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3231":"674c9c0d","3572":"674c9c0d","4640":"674c9c0d","5622":"674c9c0d","6052":"674c9c0d","6181":"674c9c0d","6464":"1f8a93ae"}[chunkId] + ".chunk.css";
};